import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class DestinationsIcon extends PureComponent {
  static propTypes = {
    fill: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static defaultProps = {
    fill: 'currentColor',
    width: '24px',
    height: '24px'
  }

  render() {
    const { width, height, fill } = this.props
    return (
      <svg width={width} height={height} viewBox="0 0 24 24">
        <path
          d="M13.586 13H1a1 1 0 0 1 0-2h12.586l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a.997.997 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L13.586 13zM4.929 4.929a1 1 0 0 1-1.414-1.414c4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97-4.686 4.687-12.284 4.687-16.97 0a1 1 0 0 1 1.414-1.414c3.905 3.905 10.237 3.905 14.142 0 3.905-3.905 3.905-10.237 0-14.142-3.905-3.905-10.237-3.905-14.142 0z"
          fill={fill}
        />
      </svg>
    )
  }
}
